import { indexedDbKioskStore, type KioskStore } from "./store";

/** The two things kiosk code needs from the device: where it stores things, and a hard navigation. Tests swap both. */
export interface KioskHost {
  store: KioskStore;
  /**
   * A full page load, not a router push. Entering or leaving kiosk mode drops every in-memory staff object
   * (query cache, session store), so nothing from one mode can survive into the other.
   */
  assign(url: string): void;
}

let current: KioskHost | null = null;
export const kioskHost = (): KioskHost => (current ??= { store: indexedDbKioskStore(), assign: (url) => window.location.assign(url) });
export const setKioskHost = (host: KioskHost | null) => { current = host; };
